/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * Determines how the OIDC login page is presented to the user; defaults to popup.
 * @export
 */
export const OIDCUXMode = {
    Popup: 'popup',
    Redirect: 'redirect'
} as const;
export type OIDCUXMode = typeof OIDCUXMode[keyof typeof OIDCUXMode];


export function instanceOfOIDCUXMode(value: any): boolean {
    for (const key in OIDCUXMode) {
        if (Object.prototype.hasOwnProperty.call(OIDCUXMode, key)) {
            if (OIDCUXMode[key as keyof typeof OIDCUXMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OIDCUXModeFromJSON(json: any): OIDCUXMode {
    return OIDCUXModeFromJSONTyped(json, false);
}

export function OIDCUXModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OIDCUXMode {
    return json as OIDCUXMode;
}

export function OIDCUXModeToJSON(value?: OIDCUXMode | null): any {
    return value as any;
}

export function OIDCUXModeToJSONTyped(value: any, ignoreDiscriminator: boolean): OIDCUXMode {
    return value as OIDCUXMode;
}

